// components/PreEmployment/CertificateView.tsx

import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { CheckCircle } from "lucide-react";
import CertificatePDF from "../../../pdf/CertificatePDF";
import type { CertificateViewProps } from "../../../types/preEmployment.types";
import CertificateActions from "./CertificateActions";
import CertificateContent from "./CertificateContent";
import { usePdfRenderer } from "../../../hooks/usePdfRenderer";

const CertificateView: React.FC<CertificateViewProps> = ({
  constanteData,
  selectedStatus,
  onBack,
  // onReturnToDashboard,
}) => {
  const { print, download } = usePdfRenderer();

  const handlePrint = () => {
    print(
      <CertificatePDF
        constanteData={constanteData}
        selectedStatus={selectedStatus}
      />
    );
  };

  const handleDownload = () => {
    const fileName = `Certificat_Medical_${constanteData.patient.lastName.replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}_${Date.now()}.pdf`;
    download(
      <CertificatePDF
        constanteData={constanteData}
        selectedStatus={selectedStatus}
      />,
      fileName
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <CertificateActions
        onBack={onBack}
        onPrint={handlePrint}
        onDownloadPDF={handleDownload}
      />

      <CertificateContent
        constanteData={constanteData}
        selectedStatus={selectedStatus}
      />

      <div className="print:hidden flex justify-end px-4 mt-2">
        <PDFDownloadLink
          document={
            <CertificatePDF
              constanteData={constanteData}
              selectedStatus={selectedStatus}
            />
          }
          fileName={`Certificat_Medical_${constanteData.patient.lastName.replace(
            /[^a-zA-Z0-9]/g,
            "_"
          )}_${Date.now()}.pdf`}
          className="flex items-center gap-2 px-3 py-2 bg-white text-blue-600 rounded-lg border border-blue-200 hover:bg-blue-50 transition-colors"
        >
          Télécharger PDF (A5)
        </PDFDownloadLink>
      </div>

      {/* Success Message with Dashboard Return Button */}
      <div className="print:hidden max-w-4xl mx-auto px-4 pb-8 mt-8">
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-6 shadow-lg">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <CheckCircle className="w-7 h-7 text-white" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-green-900 mb-2">
                Certificat médical généré avec succès !
              </h3>
              <p className="text-green-700 mb-4">
                Le certificat médical pré-embauche a été créé. Vous pouvez
                l'imprimer ou le télécharger ci-dessus.
              </p>
              {/* Commented out automatic return button because redirect is automatic */}
              {/**
               {onReturnToDashboard && (
                 <button
                   onClick={onReturnToDashboard}
                   className="flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-1 font-medium"
                 >
                   <Home size={20} />
                   Retourner au tableau de bord
                 </button>
               )}
              */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateView;
